import * as $runtime from "../runtime.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dTime$dDuration from "../Data.Time.Duration/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
const Seconds = x => x;
const showSeconds = Data$dTime$dDuration.showSeconds;
const ordSeconds = Data$dOrd.ordNumber;
const newtypeSeconds = {Coercible0: () => {}};
const udecodeSeconds = {unsafeDecode: x => Unscramble.decodeNumber(x)};
const eqSeconds = Data$dEq.eqNumber;
const encodeSeconds = {encode: x => x};
const decodeSeconds = {
  decode: x => {
    const $0 = Foreign$dGeneric$dClass.numberDecode.decode(x);
    if ($0.tag === "Left") { return Data$dEither.$Either("Left", $0._1); }
    if ($0.tag === "Right") { return Data$dEither.$Either("Right", $0._1); }
    $runtime.fail();
  }
};
export {Seconds, decodeSeconds, encodeSeconds, eqSeconds, newtypeSeconds, ordSeconds, showSeconds, udecodeSeconds};
